import React, { memo, MouseEventHandler } from "react";
import cn from "classnames";
import styles from "./MinersTab.module.scss";

export interface ISubTabProps {
  readonly thisID: number;
  readonly currentID: number;
  readonly color: string;

  readonly tabName?: string;
  readonly hasItems?: boolean;
  readonly title?: string;
  readonly last?: boolean;
  readonly skippable?: boolean;
 
  setTab(id: number): void;
  onClick?: MouseEventHandler<HTMLDivElement>;
}

const useControl = (props: ISubTabProps) => {
  return {
    onClick(e: React.MouseEvent<HTMLDivElement>) {
      (props.onClick ?? ((e) => props.setTab(props.thisID)))(e);
    },
  }
}

function MinersSubTab(props: ISubTabProps) {
  const ctrl = useControl(props);

  return (
    <div
      className={cn(styles.tabs_btn, styles.subTab, {
        [styles.active]: props.currentID === props.thisID,
        [styles.last]: !!props.last,
        [styles.skippable]: !!props.skippable,
      })}
      onClick={ctrl.onClick}
      title={props.title}
      style={{color: props.color}}
      data-subtab-color={props.color}
    >
      <div className={styles.circle} style={{backgroundColor: props.color}}/>
      <div className={styles.text}>
        {props.tabName}
      </div>
    </div>
  );
}

export default memo(MinersSubTab);
